import { Control } from '@yleisradio/areena-types';
import React from 'react';
import PlayIcon from 'assets/playIcon.svg';
import IconStartover from 'assets/startoverIcon.svg';
import { Button, ButtonPadding, ButtonSize, ButtonVariant } from './Button';

interface PlayButtonProps {
  control: Control | undefined;
  disabled?: boolean;
  onClick: React.MouseEventHandler | undefined;
  padding: ButtonPadding | undefined;
  size: ButtonSize | undefined;
  variant: ButtonVariant | undefined;
  width: 'full' | undefined;
  dataTestId?: string | undefined;
}

export const PlayButton: React.FunctionComponent<PlayButtonProps> = ({
  control,
  disabled = false,
  onClick,
  padding,
  size,
  variant = 'primary',
  width,
  dataTestId,
}) => {
  if (!control) return null;

  return (
    <Button
      text={control.title || ''}
      onClick={onClick}
      padding={padding}
      size={size}
      variant={variant}
      iconLeft={control.icon?.id === 'startover' ? IconStartover : PlayIcon}
      width={width}
      dataTestId={dataTestId}
      disabled={disabled}
    />
  );
};
